import { Controller, useFormContext } from "react-hook-form";
import { Switch, SwitchProps } from "./switch";

export type ControlledSwitchProps = Omit<
  SwitchProps,
  "onValueChange" | "isSelected"
> & {
  name: string;
};

export function ControlledSwitch({ name, ...props }: ControlledSwitchProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <Switch
            {...props}
            isSelected={field.value}
            onValueChange={(checked: boolean) => {
              field.onChange(checked);
            }}
          />
        );
      }}
    />
  );
}
